/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export enum ASACategory {
  ASA_I = 'ASA I - A Normal Healthy Patient',

  ASA_II = 'ASA II - A Patient With Mild Systemic Disease',

  ASA_III = 'ASA III - A Patient With Severe Systemic Disease',

  ASA_IV = 'ASA IV - A Patient With Severe Systemic Disease That Is A Constant Threat To Life',

  ASAV_V = 'ASA V - A Moribund Patient Who Is Not Expected To Survive Without The Operation',

  ASA_VI = 'ASA VI - A Declared Brain-dead Patient Whose Organs Are Being Removed For Donor Purposes',
}
